<template>
    <v-card class="ticket-container rounded-lg mt-4 px-4 py-3" elevation="1">
        <ticket-status-header
            :geography="geography"
            :category-name="categoryName"
            :status="status"
            :validity-time="validityTime"
            :name="name"
            :order-time="orderTime"
        />
        <div v-if="orderTime" class="ticket-alert pt-3">
            <div class="text-size-xs text-secondary-light d-flex">
                <span class="ticket-alert-message">
                    <div v-if="isWithinDeliveryTime(orderTime)" class="mb-2">
                        {{ getReminderText.before }}
                        <span class="time-highlight">{{ orderTimeNotification }}</span>
                        {{ getReminderText.after }}
                    </div>
                    <div class="mt-2">
                        <strong class="text-secondary-dark">{{ t('travelCard.remember') }}!</strong>
                        {{ t('travelCard.activationReminder') }}
                    </div>
                </span>
            </div>
        </div>
    </v-card>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import TicketStatusHeader from './TicketStatusHeader.vue';
import { CardProductDto } from '@/types/webapi';
import { PURCHASE_NOTIFICATION_VISIBILITY_VALUE } from '@/constants';
import { formatTimestamp, splitTextPattern } from '@/helpers';
import { isWithinDeliveryTime } from '../../../helpers';

const { t } = useI18n();

const props = defineProps<CardProductDto & { showMultiplePendingTicketIndicator: boolean }>();

const getReminderText = computed(() => splitTextPattern(t('travelCard.productReadyAt'), '[TIME]'));

const orderTimeNotification = computed(() =>
    formatTimestamp(props.orderTime, 'HH:mm', { addHours: PURCHASE_NOTIFICATION_VISIBILITY_VALUE })
);
</script>
